import Model from "../classes/Model";
import Api from "../classes/api/History";
import User from "./User";

export default class History extends Model {

    static TYPE_INSERT = 1;
    static TYPE_UPDATE = 2;

    get id() {
        return this._id;
    }

    set type(value) {
        this._type = value;
    }
    get type() {
        return this._type;
    }
    set table(value) {
        this._table = value;
    }
    get table() {
        return this._table;
    }

    set data(value) {
        this._data = value;
    }
    get data() {
        return this._data;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    set creator(value) {
        this._creator = value;
    }
    get creator() {
        return this._creator;
    }


    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
    }

    static toResponse(data) {

        let creator = null;
        if (undefined !== data.creator && data.creator) {
            creator = new User(User.toResponse(data.creator));
        }

        let jsonData = {};
        if (undefined !== data.json && data.json) {
            jsonData = JSON.parse(data.json);
        }

        return {
            id: data.id,
            type: data.type,
            table: data.table,
            data: jsonData,
            createdAt: data.created_at,
            createdBy: data.created_by,
            creator: creator,
        };
    }

    static getList(targetId, tables, page = 1, perPage = 10, sort = undefined, extraFields = []) {
        return Api.getList(targetId, tables, page, perPage, sort, extraFields).then((response) => {
            let data = [];
            for (let history of response.data) {
                data.push(new this(this.toResponse(history)));
            }
            return {data, headers: response.headers};
        });
    }

}
